/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '[target="_blank"]' ).append( '<span class="sr-only">(opens in new window)</span>' );

      $( '.footer-nav-toggle' ).click( function() {
        $( this ).toggleClass( 'is-open' ).next().slideToggle();
      } );

      $( '.dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      const headerHeight = $( '.navbar' ).outerHeight();
      if ( $( 'body' ).hasClass( 'logged-in' ) ) {
        $( 'body' ).css( 'padding-top', ( headerHeight + 32 ) + 'px' );

        if ( window.innerWidth < 783 ) {
          $( 'body' ).css( 'padding-top', ( headerHeight + 46 ) + 'px' );
        }
      } else {
        $( 'body' ).css( 'padding-top', headerHeight + 'px' );

        if ( window.innerWidth < 783 ) {
          $( 'body' ).css( 'padding-top', headerHeight + 'px' );
        }
      }

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      if ( typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }

      /*
       * CALCULATORS
       */
      const calcWidth = $( '.calculator-page #KJECalculatorTable' ).width();
      $( '.calculator-info, #KJEDefinitions' ).width( calcWidth );
      // SpeedBump for external links offsite.
      $( function() {
        document.addEventListener( 'click', function( e ) {
          const link = e.target.closest( 'a' );
          if ( !link ) {
            return;
          }

          const href = link.getAttribute( 'href' );
          if ( !href ) {
            return;
          }
          let url;
          try {
            url = new URL( href, window.location.origin );
          } catch ( err ) {
            return;
          }
          if (
            url.hostname === window.location.hostname ||
                url.protocol === 'mailto:' ||
                url.protocol === 'tel:' ||
                url.protocol === 'javascript:'
          ) {
            return;
          }
          e.preventDefault();

          const proceed = confirm(
              'You are leaving the Bison State Bank website.\n\n' +
                'You are about to visit:\n' +
                url.href +
                '\n\n' +
                'Bison State Bank is not responsible for the content ' +
                'or security of the external site.\n\n' +
                'Do you wish to continue?'
          );

          if ( proceed ) {
            if ( link.target === '_blank' ) {
              window.open( url.href, '_blank', 'noopener,noreferrer' );
            } else {
              window.location.href = url.href;
            }
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
